import service from "./service";

export const avatar = image => {
  return service.postFormData("/v1/upload/avatar", image);
};
